// fieldsToSections.js
export default function fieldsToSections(fieldsArray) {
  if (!Array.isArray(fieldsArray)) return [];
  const sectionMap = {};
  for (const field of fieldsArray) {
    const group = field.groupName || "";
    if (!sectionMap[group]) sectionMap[group] = [];
    const { groupName, ...rest } = field;
    sectionMap[group].push(rest);
  }
  return Object.entries(sectionMap).map(([section, fields]) => ({
    section,
    fields,
  }));
}
